<template>
  <div class="videodetail">
    <div class="videodetail-top">
      <div class="left">
        <img :src="videoDetail.avatar" alt>
      </div>
      <div class="right">
        <p class="tit">{{ videoDetail.title }}</p>
        <div class="infokv">
          <label class="label10">运行状态：</label>
          <div v-if="videoDetail.status == 1">
            <span class="dot1"></span>
            在线
          </div>
        </div>
        <div class="infokv">
          <label class="label10">通道ID：</label>
          <div class="aisleId">{{ videoDetail.aisleId }}</div>
        </div>
      </div>
    </div>
    <div class="videodetail-tit">基本信息</div>
    <div class="videodetail-main">
      <div class="infokv">
        <label class="label10">经度：</label>
        <div>{{ videoDetail.longitude }}</div>
      </div>
      <div class="infokv">
        <label class="label10">行政区划：</label>
        <div>{{ videoDetail.area }}</div>
      </div>
      <div class="infokv">
        <label class="label10">行业：</label>
        <div>{{ videoDetail.job }}</div>
      </div>
      <div class="infokv">
        <label class="label10">地址：</label>
        <div>{{ videoDetail.address }}</div>
      </div>
      <div class="infokv">
        <label class="label10">纬度：</label>
        <div>{{ videoDetail.latitude }}</div>
      </div>
      <div class="infokv">
        <label class="label10">朝向：</label>
        <div>{{ videoDetail.direction }}</div>
      </div>
      <div class="infokv">
        <label class="label10">建筑单位名称：</label>
        <div>{{ videoDetail.company }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      videoDetail: {
        avatar:
          "https://argus-cdn.ts-it.cn/aiservice/50ad3e11fdef49beb11b3a0ac0fe50b6.jpg",
        title: "洪家楼北路花园路路口",
        status: 1,
        aisleId: "123488866633455", //通道id
        longitude: "728725629", //经度
        area: "济南市历下区千佛山街道", //行政区划
        job: "农业",
        address: "洪家楼北路花园路路口",
        latitude: "7897797", //纬度
        direction: "北",
        company: "农业局"
      }
    };
  },
  created() {},
  methods: {
    link(path) {
      this.$router.push({ path: path });
    }
  }
};
</script>

<style lang="scss">
.videodetail {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 24px 32px;
  overflow: auto;
  &-top {
    display: flex;
    .left {
      img {
        width: 324px;
        height: 182px;
        border-radius: 4px;
      }
    }
    .right {
      height: 182px;
      box-sizing: border-box;
      flex: 1;
      padding: 34px 20px;
      > .tit {
        font-size: 20px;
        font-family: MicrosoftYaHeiSemibold;
        color: #2f4061;
        font-weight: bold;
      }
      .label10 {
        width: 5em;
        text-align: left;
      }
      .aisleId {
        margin-left: -15px;
      }
      .dot1 {
        display: inline-block;
        background: #67c23a;
        width: 6px;
        height: 6px;
        border-radius: 50%;
      }
    }
  }
  &-tit {
    font-size: 16px;
    font-family: MicrosoftYaHeiSemibold;
    color: #2f4061;
    font-weight: bold;
    border-bottom: 1px solid #ebedf0;
    padding: 25px 0 15px;
  }
  &-main {
    .label10 {
      width: 7em;
    }
  }
}
</style>